import React, { useEffect } from "react";
import Status from "./Status";
import "./ShoppingPremierToken.css";
import { coinIcon } from "../../Constants/assets";
import { CurrencyOptions } from "../../Constants/retailer";
const PercentCoin = require("../../assets/media/coins/percent-coin.png");
const ShoppingPremierToken = ({
  shoppingToken,
  premierToken,
  onSwitchStatus,
  territory,
  onEdit,
}) => {
  return (
    <div className="token-wrapper">
      <div className="token-summary-container">
        <img src={PercentCoin} alt="coin" style={{ marginLeft: -40 }} />
        <div className="status-container">
          <label style={{ color: "black", lineHeight: 1.2 }}>
            Shopping <br />
            tokens
          </label>
          {shoppingToken && (
            <Status
              isLive={shoppingToken.isLive}
              onSwitchStatus={() => onSwitchStatus(5)}
              onEdit={() => onEdit(5)}
              dataTarget="#token-description-modal"
            />
          )}
        </div>
        <div className="text-container">{shoppingToken.text}</div>
      </div>
      <div className="token-summary-container" style={{ marginLeft: 10 }}>
        <img src={coinIcon[territory]} alt="coin" style={{ marginLeft: -40 }} />
        <div className="status-container">
          <label style={{ color: "black", lineHeight: 1.2 }}>
            Premier
            <br />
            tokens
          </label>
          {premierToken && (
            <Status
              isLive={premierToken.isLive}
              onSwitchStatus={() => onSwitchStatus(6)}
              onEdit={() => onEdit(6)}
              dataTarget="#token-description-modal"
            />
          )}
        </div>
        <div className="text-container">
          {premierToken.text.replace("*Currency*", CurrencyOptions[territory])}
        </div>
      </div>
    </div>
  );
};
export default ShoppingPremierToken;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/ShoppingPremierToken.js